import { Api } from '@/services/Api';

export default {
  getTrees () {
        return Api().get('/Tree/GetTrees');
    }, 
  getTree (id) {
    return Api().get(`/Tree/${id}`);
  },
  saveTree (body) {
    return Api().post(`/Tree`, body);
  },
  deleteTrees (trees) {
    return Api().post(`/Tree/DeleteTree`, trees);
    },
/*  5. post one or more row */
  postTrees (trees) {
    return Api().post(`/Tree/PostTree`, trees);
  },
    searchNode(body = { keyWord:''}) {
    return Api().post(`/Tree/GetTrees`, body);
  },
}